import Badge from './Badge.jsx'

export default function RecordStatus({ value }) {
  const tones = { approved: 'success', active: 'success', admin: 'success', proposed: 'warning', needs_review: 'warning', pending: 'warning', rejected: 'danger', draft: 'neutral', deprecated: 'neutral', inactive: 'neutral' }
  return <Badge tone={tones[value] || 'neutral'}>{String(value || 'unknown').replaceAll('_', ' ')}</Badge>
}
